import React from 'react';
import * as DEFAULT_COLORS from '../../constants/defaultColors';

const DEFAULT_BORDER_COLOR = '#1064ae';

export const initResultContainerStyleData = {
  style: {
    // flex: 5,
    width: '480px',
    backgroundColor: DEFAULT_COLORS.DEFAULT_BG_COLOR,
    backgroundImage: `linear-gradient(to right, ${DEFAULT_COLORS.DEFAULT_BG_COLOR})`,
    borderRadius: 10,
    boxShadow: `-10px 0px 20px #1896ff, 10px 10px 10px #515151`,
    borderTopWidth: 1,
    borderTopColor: DEFAULT_BORDER_COLOR,
    borderTopStyle: 'solid',
    borderRightWidth: 1,
    borderRightColor: DEFAULT_BORDER_COLOR,
    borderRightStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: DEFAULT_BORDER_COLOR,
    borderBottomStyle: 'solid',
    borderLeftWidth: 1,
    borderLeftColor: DEFAULT_BORDER_COLOR,
    borderLeftStyle: 'solid',
  },
  bgColorsList: [DEFAULT_COLORS.DEFAULT_BG_COLOR],
};

const setContainerStyleData = () => {};

const ContainerStyleContext = React.createContext({containerStyleData: initResultContainerStyleData, setContainerStyleData});

export default ContainerStyleContext;
